import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-blue-950 py-16 sm:py-20" aria-labelledby="guarantee-title" data-id="element-101" data-mp="4vry1r9ge1np">
      <div className="mx-auto max-w-2xl px-4 text-center" data-id="element-102" data-mp="9tl7qu9ytdsq">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="rounded-2xl border border-slate-300/30 bg-blue-900 p-8 shadow-lg shadow-black/20 sm:p-12" data-id="element-103" data-mp="et620re6wxz4">
          <span className="silver-metal inline-flex rounded-full p-4 text-blue-950" data-id="element-104" data-mp="sm5j2xtmf08s">
            <ShieldCheckIcon className="h-10 w-10" aria-hidden="true" data-id="element-105" data-mp="xk74vqifldny" />
          </span>
          <h2 id="guarantee-title" className="mt-6 text-3xl font-extrabold text-white" data-id="element-106" data-mp="12jjxyszwbgyz">
            Garantía total de 7 días
          </h2>
          <p className="mt-4 leading-relaxed text-slate-200" data-id="element-107" data-mp="17imx5wt72sz1">
            Abre los 9 tomos. Revisa los 5 bonos. Úsalos en tu clase más difícil esta semana. Si sientes que tus alumnos
            no respondieron mejor, o que el material no te ahorró horas de trabajo:
          </p>
          <p className="mt-6 rounded-lg border border-slate-300/40 bg-blue-950 px-5 py-4 text-lg font-extrabold text-white" data-id="element-108" data-mp="1vuitepvmg97q">
            Te devolvemos el 100% de tu dinero. Sin preguntas. Sin formularios. Sin complicaciones.
          </p>
          <p className="mt-5 text-sm leading-relaxed text-slate-300" data-id="element-109" data-mp="2ok99v5kq7n70">
            Porque si el material no te da el valor que prometemos, no queremos quedarnos con tu dinero.
          </p>
        </motion.div>
      </div>
    </section>;
}